import { createAction, props } from '@ngrx/store';
import { PaginationResponse } from '@shared/models/common.model';
import { VaultListItem } from '../../models/vault.model';
import { WalletListItem } from '../../models/wallet.model';

// Load Actions
export const loadVaults = createAction(
  '[Vault] Load Vaults',
  props<{ page?: number; limit?: number; append?: boolean }>()
);

export const loadVaultsSuccess = createAction(
  '[Vault] Load Vaults Success',
  props<{
    data: VaultListItem[];
    pagination: PaginationResponse;

    append: boolean;
  }>()
);

export const loadVaultsFailure = createAction(
  '[Vault] Load Vaults Failure',
  props<{ error: string }>()
);

// Load Wallets Actions
export const loadWallets = createAction(
  '[Vault Detail] Load Wallets',
  props<{ vaultId: string; page: number; limit: number; append?: boolean }>()
);

export const loadWalletsSuccess = createAction(
  '[Vault Detail] Load Wallets Success',
  props<{
    wallets: WalletListItem[];
    pagination: PaginationResponse;
    append: boolean;
  }>()
);

export const loadWalletsFailure = createAction(
  '[Vault Detail] Load Wallets Failure',
  props<{ error: string }>()
);
